module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('static.orders.edit.modalFormTitle')) + " ("), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "href": ("/#/products/" + _vm.productId + "/edit#productInfo"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.goToEditPage')))]), _vm._v(")")]), _vm._v(" "), (!_vm.loading) ? _c('v-form', {
    attrs: {
      "form": _vm.form,
      "hasLabel": true,
      "translation": "form.products",
      "save": _vm.onSubmit
    }
  }) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('br'), _c('br')])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-149e038b","hasScoped":true}!./src/app/components/quickProductEdit/quickProductEdit.html
// module id = 2921
// module chunks = 1